const appReadyMiddleware = () => (next) => (action) => {
	return next(action);
};

export default appReadyMiddleware;
